<template>

	<div>

		<div class="competitors" v-if="competitorArray.length>0||showAdd">
			<span class="large-button mini" @click="showTagger" v-if="showAdd" v-html="competitorArray.length>0?'Edit Competitors':'Add Competitors'" />
			<p v-if="competitorArray.length===0">You can add the domains of your competitors and they will be tracked against your keywords</p>
			<slot />
			<Switcher 
				v-if="competitorArray.length>0"
				v-model="showCompetitors2"
				:sameColour="true"
				class="switcher"
			/>
			<div class="competitor-list" v-if="showCompetitors2&&competitorArray.length>0">
				<span 
					v-for="(competitor, competitorIndex) in competitorArray" 
					:key="competitorIndex" 
					:class="{selected:competitors[competitor]}"
					@click="toggleCompetitor(competitor)"
					v-html="competitor"
					:title="competitors[competitor]?'Hide':'Show'"
				/>
			</div>
		</div>

		<Tagger 
			v-if="taggerVisible" 
			:settings="taggerSettings"
			:tags="competitorArray" 
			@close-tagger="closeTagger"
			:lowerCaseTags="false"
			:unusedTitle="'These Will Be Deleted When You Close The Modal'"
		/>

	</div>

</template>

<script>
import Vue from 'vue';
import Tagger from './Tagger.vue'
import Switcher from './Switcher.vue'
import general from './../utils/general'
export default {
  name: 'Competitors',
  components: { Tagger, Switcher },
  props: {
	competitors: {
		type: Object,
		default: () => { return {} }
	},
	showCompetitors: {
		type: Boolean
	},
	showAdd: {
		type: Boolean,
		default: true
	}
  },
  data() {
	return {
		taggerVisible: false,
		competitorsObject: {},
		showCompetitors2: false
	}
  },
  watch: {
	showCompetitors () {
		this.showCompetitors2 = this.showCompetitors;
	},
	competitors () {
		Vue.set( this, 'competitorsObject',  JSON.parse( JSON.stringify( this.competitors ) ));
	},
	showCompetitors2 () {
		this.update ();
	}
  },
  computed: {

	competitorArray () {

		let c = [];

		Object.keys( this.competitorsObject ).forEach( competitorDomain => {

			if ( !competitorDomain || competitorDomain === 'undefined' ) return;

			c.push( competitorDomain );

		});

		return c;

	},

    taggerSettings () {
		return {
			type: 'domains',
			title: "Add/Delete Competitor Domains",
			returnOnly: true,
			tags: this.competitorArray,
			saveOnClose: true,
			availableTags: this.competitorArray
		}
	}

  },
  methods: {

	toggleCompetitor (competitor) {

		this.competitorsObject[competitor] = !this.competitorsObject[competitor];
		this.update ( true );

	},
  
	showTagger () {

		this.taggerVisible = true;

	},
	closeTagger (info) {
		
		this.taggerVisible = false;
		general.modalClose();

		this.update ( info );

	},
	update ( info ) {
		
		let current = JSON.parse( JSON.stringify( this.competitorsObject ) ),
			updated = JSON.parse( JSON.stringify( this.competitorsObject ) ),
			update = { showCompetitors: this.showCompetitors2 };

		if ( info  ) {

			if ( typeof info === 'object' ) {

				updated = {};

				info.tags.forEach ( function (tag) {

					updated[tag] = typeof current[tag] !== 'undefined' ? current[tag] : true;

				});

				if ( Object.keys( current ).length === 0 ) {

					update.showCompetitors = true;
					this.showCompetitors2  = true;

				}

			}

			update.competitors = updated;

		}
		
		this.$emit( 'save', update );

	}

  },
  mounted () {
	
	Vue.set( this, 'competitorsObject',  JSON.parse( JSON.stringify( this.competitors ) ));
	Vue.set( this, 'showCompetitors2', this.showCompetitors );

  }
}
</script>
<style lang="less" scoped>
@import './../assets/css/less/_helper.less';
@import './../assets/css/less/_settings.less';

.competitors {

	margin: 20px 0 0;

	.switcher {

		margin-top: 9px;

	}

	p, .competitor-list {

		display: inline-block;
		padding: 0;
		margin: 0;
		vertical-align: top;

	}

	p {

		margin-top: 9px;
		margin-left: 10px;

	}

	.large-button.mini {

		margin-bottom: 0px;
		margin-top: 6px;

	}

	.competitor-list {

		span {

			.opacity(0.5);
			cursor: pointer;
			padding: 0 0 0 10px;
			margin-top: 10px;
    		display: inline-block;

			&:before {

				content:" • ";
				display: inline-block;
				padding-right: 10px;

			}

			&:hover {

				.opacity(1);

			}

			&.selected {

				.opacity(1);

				&:hover {

					.opacity(0.5);

				}

			}

			&:first-child {

				padding: 0;

				&:before {

					display: none;

				}

			}

		}

	}

}

</style>